import { FieldValues } from 'react-hook-form'

import { ClientError, ErrorResponse } from '@tribeplatform/gql-client/lib'

export const extractFieldsErrors = (
  error: ClientError,
): Record<string, { message: string; itemIndex: number }> =>
  error?.response?.errors?.reduce((errors, currentError) => {
    const [fieldKey, failingItemIndex] = currentError?.field?.split('.')
    if (fieldKey === 'fields') {
      return {}
    }

    return {
      ...errors,
      [fieldKey]: {
        message: currentError.message,
        ...(failingItemIndex
          ? { itemIndex: parseInt(failingItemIndex, 10) }
          : {}),
      },
    }
  }, {})

export const flattenFormSubmitErrors = (
  error: ClientError,
): ErrorResponse[] => {
  const extractSubErrors = (error: ErrorResponse): ErrorResponse[] => {
    if (error.errors) {
      const subErrors = error.errors.flatMap(extractSubErrors)
      return [error, ...subErrors]
    }

    return [error]
  }

  return error.response?.errors?.flatMap(extractSubErrors) ?? []
}
// RHF submits all fields data on submit, regardless of whether they are dirty or not.
// https://github.com/orgs/react-hook-form/discussions/1991
export const getFormUpdatedFields = <T extends FieldValues>(
  allFields: T,
  dirtyFields: Partial<Record<keyof T, boolean>>,
): Partial<T> => {
  const changedFieldValues = Object.keys(dirtyFields).reduce(
    (acc, currentField) => {
      return {
        ...acc,
        [currentField]: allFields[currentField],
      }
    },
    {} as Partial<T>,
  )

  return changedFieldValues
}
